import { fetchPlatform } from '@/api/common';
export default {
  name: 'Login',
  created() {
    if (!this.$route.query.token) {
      fetchPlatform().then(res => {
        location.href = `${process.env.VUE_APP_PDS_URL}/#/authorize?platform=` + res.platform + '&callback=' + (location.origin + '/#' + this.$route.query.redirect);
      });
    }
  }
};